import { render, staticRenderFns } from "./BuildingConfigShow.vue?vue&type=template&id=080da087"
import script from "./BuildingConfigShow.vue?vue&type=script&lang=ts"
export * from "./BuildingConfigShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports